// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActiveSidebarItemController from "./active_sidebar_item_controller"
application.register("active-sidebar-item", ActiveSidebarItemController)

import AlternativeMethodsController from "./alternative_methods_controller"
application.register("alternative-methods", AlternativeMethodsController)

import DigitalRegistriesController from "./digital_registries_controller"
application.register("digital-registries", DigitalRegistriesController)

import DigitalRegistryFileUploadController from "./digital_registry_file_upload_controller"
application.register("digital-registry-file-upload", DigitalRegistryFileUploadController)

import EccAuditsController from "./ecc_audits_controller"
application.register("ecc-audits", EccAuditsController)

import EstimatedProductionsController from "./estimated_productions_controller"
application.register("estimated-productions", EstimatedProductionsController)

import FileAdderController from "./file_adder_controller"
application.register("file-adder", FileAdderController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import NewProducerController from "./new_producer_controller"
application.register("new-producer", NewProducerController)

import NewUserFormController from "./new_user_form_controller"
application.register("new-user-form", NewUserFormController)

import ParcelImportsController from "./parcel_imports_controller"
application.register("parcel-imports", ParcelImportsController)

import PlantationsController from "./plantations_controller"
application.register("plantations", PlantationsController)

import PreferencesController from "./preferences_controller"
application.register("preferences", PreferencesController)

import RemoteModalController from "./remote_modal_controller"
application.register("remote-modal", RemoteModalController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import EccSamplesController from "./ecc_samples_controller"
application.register("ecc-samples", EccSamplesController)

import EccDocumentsController from "./ecc_documents_controller"
application.register("ecc-documents", EccDocumentsController)
